import {
  $getRoot,
  $getSelection,
  $isElementNode,
  $isRangeSelection,
  type LexicalNode,
} from 'lexical';

type DocumentPoint = {
  key: string;
  offset: number;
};

function getFirstLeafNode(): LexicalNode | null {
  const root = $getRoot();
  if (root.getChildrenSize() === 0) {
    return null;
  }

  let node: LexicalNode | null = root.getFirstChild();
  while (node !== null && $isElementNode(node) && node.getChildrenSize() > 0) {
    node = node.getFirstChild();
  }

  return node;
}

function getFirstDocumentPoint(): DocumentPoint | null {
  const node = getFirstLeafNode();
  if (!node) {
    return null;
  }

  return { key: node.getKey(), offset: 0 };
}

function isEditorEmpty(): boolean {
  return $getRoot().getTextContent().length === 0;
}

function isSelectionAtPoint({
  point,
}: {
  point: DocumentPoint | null;
}): boolean {
  const selection = $getSelection();
  if (!$isRangeSelection(selection) || !selection.isCollapsed()) {
    return false;
  }

  if (!point) {
    return isEditorEmpty();
  }

  const anchor = selection.anchor;
  return anchor.key === point.key && anchor.offset === point.offset;
}

export function isSelectionAtDocumentStart(): boolean {
  if (isEditorEmpty()) {
    const selection = $getSelection();
    return !$isRangeSelection(selection) || selection.isCollapsed();
  }

  return isSelectionAtPoint({ point: getFirstDocumentPoint() });
}
